export const QUESTION_TYPE_MAP = [
    { id: "-2", abbreviation: "All", name: "All Types", code: "ALL" }, // All Type - Customized and added by QAP 2.0 Requirement
    { id: "-1", abbreviation: "Unknown", name: "Unknown", code: "TYPE_UNDEFINED" },
    { id: "0", abbreviation: "TF", name: "True-False", code: "TYPE_TRUE_FALSE" },
    { id: "1", abbreviation: "MC", name: "Multiple-Choice", code: "TYPE_MULTIPLE_CHOICE" },
    { id: "2", abbreviation: "MS", name: "Multiple-Selection", code: "TYPE_CHOOSE_ALL_THAT_APPLY" },
    { id: "3", abbreviation: "TE", name: "Text-Entry", code: "TYPE_FILL_IN_BLANKS_GENERIC" },
    { id: "4", abbreviation: "TE-D", name: "Text-Entry with Dropdown", code: "TYPE_FILL_IN_BLANKS_WITH_DROPDOWNS" },
    { id: "5", abbreviation: "F", name: "Formula", code: "TYPE_FORMULA" },
    { id: "6", abbreviation: "CI", name: "Click on Image", code: "TYPE_CLICK_ON_IMAGE" },
    { id: "7", abbreviation: "DD", name: "Drag-and-Drop", code: "TYPE_DRAG_AND_DROP" },
    { id: "8", abbreviation: "TE-N", name: "Text-Entry Numeric", code: "TYPE_NUMERIC" },
    { id: "9", abbreviation: "TE-NU", name: "Text-Entry Numeric with Units", code: "TYPE_NUMERIC_WITH_PHYSICAL_UNITS" },
    { id: "10", abbreviation: "TE-SP", name: "Text-Entry Short Phrase", code: "TYPE_SHORT_PHRASE" },
    { id: "11", abbreviation: "TE-K", name: "Text-Entry Keyword", code: "TYPE_KEYWORD" },
    { id: "12", abbreviation: "Mt", name: "Matching", code: "TYPE_MATCHING" },
    { id: "13", abbreviation: "Mx", name: "Matrices", code: "TYPE_MATRICES" },
    { id: "14", abbreviation: "FC", name: "Flash Card", code: "TYPE_FLASH_CARD" },
    { id: "15", abbreviation: "E", name: "Essay", code: "TYPE_ESSAY" },
    { id: "16", abbreviation: "SSS", name: "Self Study Solution", code: "TYPE_SELF_STUDY_SOLUTION" },
    { id: "17", abbreviation: "MP", name: "Multipart", code: "TYPE_MULTIPART" },
    { id: "18", abbreviation: "HS", name: "Hot Spot", code: "TYPE_HOT_SPOT" },
    { id: "19", abbreviation: "TE-N", name: "Text-Entry Numeric", code: "TYPE_PLAIN_NUMBER" },
    { id: "20", abbreviation: "ATE", name: "Accounting Text-Entry", code: "TYPE_FILL_IN_BLANKS_ACCOUNTING" },
    { id: "21", abbreviation: "ATE-D", name: "Accounting Text-Entry with Dropdown", code: "TYPE_COMPLETE_SENTENCE_ACCOUNTING" },
    { id: "22", abbreviation: "AMP", name: "Accounting Multipart", code: "TYPE_MULTIPART_ACCOUNTING" },
    { id: "23", abbreviation: "Spreadsheet", name: "Spreadsheet", code: "TYPE_SPREADSHEET" },
    { id: "24", abbreviation: "Sketch", name: "Sketch Pad", code: "TYPE_SKETCHPAD" },
    { id: "25", abbreviation: "FormulaList", name: "Choice of formulas", code: "TYPE_FORMULA_LIST" },
    { id: "26", abbreviation: "ChemPad", name: "Chemical Symbolic Notation", code: "TYPE_CHEMICAL" },
    { id: "27", abbreviation: "MolQuiz", name: "Molecular Quiz", code: "TYPE_MOLQUIZ" },
    { id: "28", abbreviation: "MathPad", name: "Mathematical Symbolic Notation", code: "TYPE_MATHPAD" },
    { id: "29", abbreviation: "TE-Text", name: "Text-Entry (Text Only)", code: "TYPE_FILL_IN_BLANKS_TEXT" },
    { id: "30", abbreviation: "GLS", name: "General Ledger Software", code: "TYPE_GLS_PROBLEM" },
    { id: "31", abbreviation: "GO", name: "GO Problem", code: "TYPE_GO_PROBLEM" },
    { id: "32", abbreviation: "Graphing", name: "Graphing", code: "TYPE_GRAPHING_MATH_PROBLEM" },
    { id: "33", abbreviation: "GD&D", name: "Drawing Drag & Drop", code: "TYPE_GRAPHING_DROP_DOWN_PROBLEM" },
    { id: "34", abbreviation: "SV", name: "Survey", code: "TYPE_SURVEY_PROBLEM" },
    { id: "35", abbreviation: "MathSN", name: "Math Symbolic Notation", code: "TYPE_MATH_SN_PROBLEM" },
    { id: "36", abbreviation: "MD", name: "Molecular Drawing", code: "TYPE_MARVIN_SKETCH_PROBLEM" },
    { id: "37", abbreviation: "Attachment", name: "Attachment (Lab Rat Full Program)", code: "TYPE_ATTACHMENT_JAVA_FULL_PROGRAM" },
    { id: "38", abbreviation: "Attachment", name: "Attachment (Lab Rat Code Completion)", code: "TYPE_ATTACHMENT_JAVA_CODE_COMPLETE" },
    { id: "39", abbreviation: "Group", name: "Group (Catalyst)", code: "TYPE_GROUP_QUESTION" },
    { id: "40", abbreviation: "VA", name: "Voice Answer", code: "TYPE_VOICE_ANSWER" },
    { id: "41", abbreviation: "Pool", name: "Pool", code: "TYPE_POOL_QUESTION" },
    { id: "42", abbreviation: "Import", name: "Import", code: "TYPE_IMPORT_QUESTION" },
    { id: "43", abbreviation: "LabelD&D", name: "Label Drag & Drop", code: "TYPE_LABEL_DRAG_AND_DROP_QUESTION" },
    { id: "44", abbreviation: "NumMpl", name: "Numeric-Maple", code: "TYPE_MAPLE_NUMERIC_QUESTION" },
    { id: "45", abbreviation: "LabelMenu", name: "Label Selection", code: "TYPE_LABEL_SELECTION_QUESTION" },
    { id: "46", abbreviation: "LabelFIB", name: "Label Fill-In", code: "TYPE_LABEL_FILL_IN_QUESTION" },
    { id: "47", abbreviation: "AMP2", name: "Accounting Multipart 2", code: "TYPE_MULTIPART_ACCOUNTING_2" },
    { id: "48", abbreviation: "MP2", name: "Multistep", code: "TYPE_MULTIPART_2" },
    { id: "49", abbreviation: "MNG", name: "Graphing-Maple", code: "TYPE_MAPLE_GRAPHING" },
    { id: "50", abbreviation: "MathMpl", name: "Math-Maple", code: "TYPE_MAPLE_TA" },
    { id: "52", abbreviation: "Learnosity Drag & Drop", name: "Learnosity Drag & Drop"},
    { id: "53", abbreviation: "Learnosity Essay", name: "Learnosity Essay"},
    { id: "54", abbreviation: "Learnosity Math", name: "Learnosity Math"},
    { id: "55", abbreviation: "Learnosity Fill in the Blanks", name: "Learnosity Fill in the Blanks"},
    { id: "56", abbreviation: "Learnosity Chemistry", name: "Learnosity Chemistry"},
    { id: "57", abbreviation: "Learnosity Free Body Diagram", name: "Learnosity Free Body Diagram"},
    { id: "58", abbreviation: "File Upload", name: "File Upload"},
    { id: "59", abbreviation: "Learnosity Alchemie", name: "Learnosity Alchemie"},
    { id: "63", abbreviation: "Gradable Excel", name: "Gradable Excel"},
    { id: "64", abbreviation: "Math Fill in the Blank", name: "Math Fill in the Blank"},
];

export const WAS_QUESTION_TYPE_MAP = [
    {
        "label": "All Types",
        "value": -2
    },
    {
        "label": "Unknown",
        "value": -1
    },
    {
        "label": "True-False",
        "value": 0
    },
    {
        "label": "Multiple-Choice",
        "value": 1
    },
    {
        "label": "Multiple-Selection",
        "value": 2
    },
    {
        "label": "Text-Entry",
        "value": 3
    },
    {
        "label": "Text-Entry with Dropdown",
        "value": 4
    },
    {
        "label": "Text-Entry Numeric",
        "value": 8
    },
    {
        "label": "Text-Entry Numeric with Units",
        "value": 9
    },
    {
        "label": "Essay",
        "value": 15
    },
    {
        "label": "Multipart",
        "value": 17
    },
    {
        "label": "Accounting Text-Entry with Dropdown",
        "value": 21
    },
    {
        "label": "Accounting Multipart",
        "value": 22
    },
    {
        "label": "Chemical Symbolic Notation",
        "value": 26
    },
    {
        "label": "Mathematical Symbolic Notation",
        "value": 28
    },
    {
        "label": "Molecular Drawing",
        "value": 36
    },
    {
        "label": "Numeric-Maple",
        "value": 44
    },
    {
        "label": "Accounting Multipart 2",
        "value": 47
    },
    {
        "label": "Multistep",
        "value": 48
    },
    {
        "label": "Learnosity Drag & Drop",
        "value": 52
    },
    {
        "label": "Learnosity Essay",
        "value": 53
    },
    {
        "label": "Learnosity Math",
        "value": 54
    },
    {
        "label": "Learnosity Fill in the Blanks",
        "value": 55
    },
    {
        "label": "Learnosity Chemistry",
        "value": 56
    },
    {
        "label": "Learnosity Free Body Diagram",
        "value": 57
    },
    {
        "label": "File Upload",
        "value": 58
    },
    {
        "label": "Learnosity Alchemie",
        "value": 59
    },
    {
        "label": "Gradable Excel",
        "value": 63
    },
    {
        "label": "Math Fill in the Blank",
        "value": 64
    }
]

export function getWASQuestionTypeName(value?: number) {
    if (!value) return '';
    const found = WAS_QUESTION_TYPE_MAP.find((t) => t.value === value);
    return found ? found.label : value;
}

export function getQuestionTypeName(abbr?: string) {
    if (!abbr) return '';
    const found = QUESTION_TYPE_MAP.find((t) => t.id === abbr);
    return found ? found.name : abbr;
}
